export default {
  GET_ROLE_MENU: (state, data) => {
    state.menu = data;
  },
  GET_MENU_TREE: (state, data) => {
    state.tree = data;
  },
  GET_MENU_PARENT: (state, data) => {
    state.parent = data;
  },
};
